import Layout from "HorizontalMenu/Menu";
import { getVesselsAction, setOnboardedVessels, setVesselID } from "Store/Generic/ReportingSlice";
import { RootState } from "index";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
    Navbar,
    Container,
    Row,
    Col,
    Label,
    Card,
    CardHeader,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    CardBody,
} from "reactstrap";
import classnames from "classnames";
import PendingVoyageAdjustment from "./PendingVoyageAdjustment";
import ApprovedVoyageAdjustment from "./ApprovedVoyageAdjustment";
import { customStyle } from "shared/CommonCSS";
import DisapprovedVoyageAdjustment from "./DisapprovedVoyageAdjustment";
import { useDocumentTitle } from "Components/useDocument.hooks";
import { OnboardingStatus } from "shared/constants";
import Message from "Components/Message";
import { getDefaultVesselValue } from "GenericForms/Helper";
import { userVessels } from "utils/auth/authUtils";

const VoyageAdjustment = () => {
    /** State variables start */
    const dispatch = useDispatch();
    let applicableVessels = userVessels();
    const { Vessels, VesselID, onboardedVessels } = useSelector(
        (state: RootState) => state.Reporting
    );
    const [activeAdjustmentsTab, setActiveAdjustmentsTab] = useState("1");
    const [tab, setTab] = useState("pending");
    const vessel = Vessels.find((rec: any) => rec.id === VesselID);
    useDocumentTitle("Voyage Adjustment - ecoSAIL");
    /** State variables end */

    /** set global vessel */
    const handleVesselSelectionChanges = (e: any) => {
        dispatch(setVesselID(e ? e?.id : null));
    };

    /** Change tabs */
    const toggle = (tab: any) => {
        if (activeAdjustmentsTab !== tab) {
            setActiveAdjustmentsTab(tab);
        }
    };
    /** useEffect */
    /** Populate Vessels array */
    useEffect(() => {
        dispatch(getVesselsAction("vessel_master" as string));
    }, [dispatch]);

    /** Effect 2: Set onboarded vessels when Vessels data is available */
    useEffect(() => {
        if (Array.isArray(Vessels)) {
            const onboardedVessels = Vessels.filter(
                (vessel) => vessel.onboarding_status === OnboardingStatus.ONBOARDED
            );
            dispatch(setOnboardedVessels(onboardedVessels));
        }
    }, [Vessels, dispatch]);
    /** useEffect end */

    return (
        <React.Fragment>
            <Layout>
                <Navbar />
            </Layout>
            <div className="page-content">
                <Container fluid>
                    <Row className="mb-2">
                        <Col sm={4}>
                            <Label className="mb-0">Select vessel</Label>
                            <Select
                                options={
                                    onboardedVessels.filter((item: any) => item.display === true &&
                                        applicableVessels?.includes(item?.id)) as any[]
                                }
                                getOptionLabel={
                                    (option: any) => option.is_under_maintenance ?
                                        `${option?.vessel_name_type_name} (Under Maintenance)` : option?.vessel_name_type_name
                                }
                                isClearable={true}
                                getOptionValue={(option: any) => option.id}
                                onChange={(e: any) => handleVesselSelectionChanges(e)}
                                menuPortalTarget={document.body}
                                styles={customStyle}
                                defaultValue={getDefaultVesselValue(
                                    VesselID,
                                    vessel,
                                    onboardedVessels,
                                    applicableVessels
                                )}
                                isOptionDisabled={(e: any) => e.is_under_maintenance}
                            />
                        </Col>
                        <Col sm={8} className="pt-3 text-end">
                            <div className="d-inline-block">
                                <h3 className="m-0">Voyage Adjustment</h3>
                            </div>
                        </Col>
                    </Row>
                    {getDefaultVesselValue(
                        VesselID,
                        vessel,
                        onboardedVessels,
                        applicableVessels
                    ) ? (
                        <Row className="mb-3 px-2">
                            <Card className="p-0">
                                <CardHeader className="pb-0">
                                    <Nav tabs className="border-0">
                                        <NavItem>
                                            <NavLink
                                                style={{ cursor: "pointer" }}
                                                className={classnames({
                                                    active: activeAdjustmentsTab === "1",
                                                })}
                                                onClick={() => {
                                                    setTab("pending");
                                                    toggle("1");
                                                }}
                                            >
                                                Pending
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                style={{ cursor: "pointer" }}
                                                className={classnames({
                                                    active: activeAdjustmentsTab === "2",
                                                })}
                                                onClick={() => {
                                                    setTab("approved");
                                                    toggle("2");
                                                }}
                                            >
                                                Approved
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                style={{ cursor: "pointer" }}
                                                className={classnames({
                                                    active: activeAdjustmentsTab === "3",
                                                })}
                                                onClick={() => {
                                                    setTab("disapproved");
                                                    toggle("3");
                                                }}
                                            >
                                                Disapproved
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                </CardHeader>
                                <CardBody className="p-0">
                                    <TabContent
                                        activeTab={activeAdjustmentsTab}
                                        className="text-muted p-0"
                                    >
                                        <TabPane tabId="1" className="mx-0 mt-2">
                                            <PendingVoyageAdjustment active={tab} />
                                        </TabPane>
                                        <TabPane tabId="2" className="mx-0 mt-2">
                                            <ApprovedVoyageAdjustment active={tab} />
                                        </TabPane>
                                        <TabPane tabId="3" className="mx-0 mt-2">
                                            <DisapprovedVoyageAdjustment active={tab} />
                                        </TabPane>
                                    </TabContent>
                                </CardBody>
                            </Card>
                        </Row>
                    ) : (
                        <Message message='Please select a vessel to proceed.' type='warning' width='367px' />
                    )}
                </Container>
            </div>
        </React.Fragment>
    );
};

export default VoyageAdjustment;
